import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LanguageServiceService {

  private isBrowser: boolean;
  private defaultLanguage = 'en';

  private currentLanguage = new BehaviorSubject<string>(this.defaultLanguage);
  currentLanguage$ = this.currentLanguage.asObservable();

  private currentDirection = new BehaviorSubject<string>('ltr');
  currentDirection$ = this.currentDirection.asObservable();

  private classToggle = new BehaviorSubject<boolean>(false);
  classToggle$ = this.classToggle.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      const savedLang = localStorage.getItem('language') || this.defaultLanguage;

      this.currentLanguage.next(savedLang);
      this.currentDirection.next(savedLang === 'ar' ? 'rtl' : 'ltr');
      this.classToggle.next(savedLang === 'ar');
    }
  }

  changeLanguage(language: string) {
    this.currentLanguage.next(language);
    this.currentDirection.next(language === 'ar' ? 'rtl' : 'ltr');
    this.classToggle.next(language === 'ar');

    if (this.isBrowser) {
      localStorage.setItem('language', language);
      window.location.reload();
    }
  }

  toggleLanguage() {
    const newLanguage = this.currentLanguage.value === 'en' ? 'ar' : 'en';
    this.changeLanguage(newLanguage);
  }
}
